import { FieldArray, useField } from "formik";
import { get } from "lodash";
import React from "react";
import { Button, Table } from "semantic-ui-react";
import RegionOption from "./RegionOption";

const RegionList = ({ name, ...props }: any) => {
  const [meta] = useField(props);
  const { value } = meta;

  const getOptions = () => {
    return get(value, name, []);
  };

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <div className='options'>
          <Table celled padded stackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={7} singleLine>
                  Option
                </Table.HeaderCell>
                <Table.HeaderCell width={7} singleLine>
                  Connect
                </Table.HeaderCell>
                <Table.HeaderCell width={1} singleLine>
                  Actions
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {getOptions().map((option: any, index: number) => (
                <RegionOption
                  key={index}
                  index={index}
                  name={`${name}[${index}]`}
                  onRemove={() => arrayHelpers.remove(index)}
                />
              ))}
            </Table.Body>
          </Table>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              icon='plus'
              basic
              primary
              type='button'
              onClick={() =>
                arrayHelpers.push({ option: "", connectTo: "HANG_UP" })
              }
            >
              Add
            </Button>
          </div>
        </div>
      )}
    />
  );
};

export default RegionList;
